export default __webpack_public_path__ + "static/media/seat-standard-unavailable.4113fa7d.svg";